/* Tiroirs des guides de la fiche (snippets/kt-guide-drawer.liquid) : le tiroir natif du thème, ouvert par eventModal
   comme « Aide à la mesure ». Chaque guide garde ses déclencheurs d'avant : le bouton de son bloc, et la classe posée
   sur un bloc « couleur + guide ». */
const TRIGGERS = {
  tailles: "#btn-open-guide, .js-open-size-guide",
  fixations: "#btn-open-guide-fixations, .js-open-fixation-guide",
};

// Modules du thème chargés au premier clic, comme le fait theme.js (ils ne servent qu'à l'ouverture).
let theme = null;
const loadTheme = () =>
  theme || (theme = Promise.all([import("@NextSkyTheme/modal"), import("@NextSkyTheme/global")]));

// « Aide à la mesure » dans un guide : le tiroir de la mesure s'ouvre par son propre écouteur (data-kt-measure-open),
// puis le guide se ferme. Dans cet ordre, le thème voit deux tiroirs ouverts et garde la page bloquée ; à la
// fermeture, il retire le piège à focus, qu'on repose sur le tiroir de la mesure.
function swapToMeasure(guide) {
  setTimeout(() => {
    const ms = document.getElementById("kt-ms");
    if (!ms || !ms.classList.contains("active")) return;
    loadTheme().then(([{ eventModal }, { global, trapFocus }]) => {
      global.rootToFocus = null;
      eventModal(guide, "close");
      trapFocus(ms.querySelector(".modal-inner"));
    });
  }, 0);
}

document.addEventListener("click", (e) => {
  const toMeasure = e.target.closest("kt-guide-drawer.active [data-kt-measure-open]");
  if (toMeasure) {
    swapToMeasure(toMeasure.closest("kt-guide-drawer"));
    return;
  }
  for (const guide in TRIGGERS) {
    const trigger = e.target.closest(TRIGGERS[guide]);
    if (!trigger) continue;
    const drawer = document.querySelector(`kt-guide-drawer[data-guide="${guide}"]`);
    if (!drawer) return;
    e.preventDefault();
    if (drawer.classList.contains("active")) return;
    loadTheme().then(([{ eventModal }, { global }]) => {
      // Option mobile du thème : sous 1025 px, la feuille du bas se ferme en tirant l'en-tête (draggable-modal).
      eventModal(drawer, "open", false, null, true);
      // À la fermeture, le thème rend la main au déclencheur.
      global.rootToFocus = trigger;
    });
    return;
  }
});

class KtGuideDrawer extends HTMLElement {
  connectedCallback() {
    // Sous <body> : un ancêtre transformé de la fiche décalerait le tiroir fixe. Un guide peut être rendu deux fois
    // (bloc des tailles et bloc « couleur + guide ») : le dernier rendu remplace les autres, ce qui garde aussi le
    // tiroir à jour quand l'éditeur recharge une section.
    if (this.parentElement !== document.body) {
      document
        .querySelectorAll(`kt-guide-drawer[data-guide="${this.dataset.guide}"]`)
        .forEach((el) => el !== this && el.remove());
      document.body.appendChild(this);
      return;
    }
    if (this.ready) return;
    this.ready = true;
    // Échap ferme la vidéo du guide (son <dialog>), pas le tiroir avec elle : modal-overlay ferme le tiroir au keyup.
    this.addEventListener(
      "keydown",
      (e) => {
        if (e.key === "Escape") this.escInDialog = !!this.querySelector("dialog[open]");
      },
      true,
    );
    this.addEventListener(
      "keyup",
      (e) => {
        if (e.key !== "Escape" || !this.escInDialog) return;
        this.escInDialog = false;
        e.stopPropagation();
      },
      true,
    );
  }
}

if (!customElements.get("kt-guide-drawer")) customElements.define("kt-guide-drawer", KtGuideDrawer);
